import { useCallback, useMemo } from "react";

import Box from "ds/components/Box";
import CodeSnippetBlock from "ds/components/CodeSnippetBlock";
import Typography from "ds/components/Typography";
import useAnalytics from "hooks/useAnalytics";
import { ModuleInput, TerraformWorkflowTool } from "types/generated";
import { generateModuleExample } from "views/Account/Module/Version/components/InstructionsDrawer/helpers";

type ModuleVersionInstructionsDrawerProps = {
  inputs: ModuleInput[] | undefined;
  moduleName: string;
  type: string;
  submodulePath?: string;
  versionNumber: string;
  moduleSource: string;
  workflowTool: TerraformWorkflowTool;
};

const ModuleVersionInstructionsDrawerContent = ({
  inputs,
  moduleName,
  submodulePath,
  type,
  versionNumber,
  moduleSource,
  workflowTool,
}: ModuleVersionInstructionsDrawerProps) => {
  const sourceUrl = type === "module" ? moduleSource : `${moduleSource}//${submodulePath}`;

  const moduleExample = useMemo(() => {
    return generateModuleExample(moduleName, sourceUrl, versionNumber, inputs);
  }, [moduleName, sourceUrl, versionNumber, inputs]);

  const trackSegmentAnalyticsEvent = useAnalytics();

  const trackInstructionCopyEvent = useCallback(() => {
    trackSegmentAnalyticsEvent("Module Registry - Instructions Copied");
  }, [trackSegmentAnalyticsEvent]);

  return (
    <Box direction="column" gap="x-large">
      <Typography variant="p-body2" tag="p">
        Copy and paste into your{" "}
        {workflowTool === TerraformWorkflowTool.OpenTofu ? "OpenTofu" : "Terraform"} configuration
      </Typography>
      <CodeSnippetBlock language="hcl" allowCopy onCopy={trackInstructionCopyEvent}>
        {moduleExample}
      </CodeSnippetBlock>
    </Box>
  );
};

export default ModuleVersionInstructionsDrawerContent;
